// extracted by mini-css-extract-plugin
export default {"gift":"gift__VvRW4"};